import { normalizeString } from "../../functions";

const _getTertiaryString = ({ fundingSource, isRecurring, recurrence }) => {
  let ret = "";
  if (isRecurring) {
    ret = normalizeString({ data: recurrence, actions: ["capitalize"] });

    return `- ${ret}`;
  } else return "";
};

const FundingSource = ({
  fundingSource,
  isRecurring,
  isRollover,
  recurrence,
}) => {
  let primary = null;
  let secondary = null;

  if (!fundingSource) {
    primary = "Bank Account";
    secondary = "(deleted)";
  } else {
    primary = fundingSource.nickname;
  }
  if (fundingSource?.accountNumber)
    secondary = `(${
      fundingSource.bankName
    } *${fundingSource.accountNumber.slice(-3)})`;
  if(isRollover) primary =`Rollover `
  return `${primary} ${secondary || ""} ${_getTertiaryString({
    isRecurring,
    fundingSource,
    recurrence,
  })}`;
};

export default FundingSource;
